import { render } from "./ResourceBoard.vue?vue&type=template&id=f0dc4276"
import script from "./ResourceBoard.vue?vue&type=script&lang=js"
export * from "./ResourceBoard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__